const searchProject = () => {
    const search = document.querySelector(".search-project");
    let timer;
    if (search) {
        const searchContent = search.querySelector(".search-project__content");
        const searchMenu = search.querySelector(".search-project__menu");
        const searchClose = search.querySelector(".search-project__close");
        const searchCloseOuter = search.querySelector(".search-project__close--outer");
        const searchInput = search.querySelector(".header__search-form-input");
        searchClose.addEventListener("click", function() {
           search.classList.remove("active");
           searchInput.value = "";
        });
        searchCloseOuter.addEventListener("click", function() {
           search.classList.remove("active");
        });
        search.addEventListener("click", function(e) {
            if (e.target.classList.contains("search-project__total") && e.target.dataset.hasOwnProperty("result")) {
                if (e.target.dataset.result === "true") this.submit();
            }
        });
        searchInput.addEventListener("focus", function() {
            if (this.value.trim().length > 2) {
                search.classList.add("active");
            }
        });
        search.addEventListener("input", function(e) {
            clearTimeout(timer);
            const action = this.action;
            const url = `${action}?suggest=1`;
            if (e.target.value.trim().length > 2) {
                this.classList.add("active");
                searchContent.innerHTML = "";
                searchMenu.innerHTML = "";
                this.classList.remove("result");
                this.classList.remove("empty");
                this.classList.remove("empty-menu");
                this.classList.add("loading");
                const q = `&q=${e.target.value}`;
                timer = setTimeout(() => {
                    fetch(`${url}${q}`)
                        .then(res => res.json())
                        .then(res => {
                            const {html, totalContents} = res;
                            this.classList.remove("loading");
                            this.classList.add("result");
                            searchContent.innerHTML = html?.content ? html.content : "";
                            searchMenu.innerHTML = html?.menu ? html.menu : "";
                            totalContents ? this.classList.remove("empty") : this.classList.add("empty");
                            if (html.menu.trim() && !totalContents) {
                                this.classList.remove("empty");
                                searchContent.querySelector("[data-result]").dataset.menu = "true";
                            }
                            html.menu.trim() ? this.classList.remove("empty-menu") : this.classList.add("empty-menu");
                        })
                        .catch(err => {
                            console.log(err);
                            this.classList.remove("loading");
                            this.classList.remove("result");
                            this.classList.remove("empty");
                            this.classList.remove("empty-menu");
                            this.classList.remove("active");
                            searchContent.innerHTML = "";
                            searchMenu.innerHTML = "";
                        })
                }, 300);
            }
            else {
                this.classList.remove("active");
                this.classList.remove("loading");
                this.classList.remove("result");
                this.classList.remove("empty");
                this.classList.remove("empty-menu");
                searchContent.innerHTML = "";
                searchMenu.innerHTML = "";
            }
        });
    }
}
export default searchProject;